import { E_REPORT_ACTIONS_LAYOUT, REPORT_ACTIONS } from '@common/configs';
import { classesBuilder } from '@common/helpers';
import Icon from '@components/Icon';

import type { IReportActionsProps } from './types';

import style from './styles.module.scss';

const ReportActions = (props: IReportActionsProps) => {
  const { layout = E_REPORT_ACTIONS_LAYOUT.LIST } = props;

  return (
    <>
      <div className={style['actions-title']}>
        <Icon name="reportActions" />
        <h4>REPORT ACTIONS</h4>
      </div>
      <ul className={classesBuilder({ [style[layout]]: true })}>
        {REPORT_ACTIONS.map((action) => {
          return (
            <li key={action.title}>
              {action.href ? (
                <a
                  href={action.href}
                  className={style.action}
                >
                  {action.icon}
                  {action.title}
                </a>
              ) : (
                <div className={style.action}>
                  {action.icon}
                  {action.title}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default ReportActions;
